var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "section",
        [
          _c("AdvanceTable", {
            ref: "advanceTable",
            attrs: {
              url: "/crm/pipeline",
              height: _vm.window.height - 310,
              columns: _vm.columns,
              pageOptions: [50, 100, 200],
              defaultPageSize: 50,
            },
            on: { clear: _vm.clearData, edit: _vm.openModalForEdit },
            scopedSlots: _vm._u([
              {
                key: "title",
                fn: function () {
                  return [_vm._v(" " + _vm._s(_vm.$t("Pipeline")) + " ")]
                },
                proxy: true,
              },
              {
                key: "button",
                fn: function () {
                  return [
                    _c(
                      "b-button",
                      {
                        staticClass: "mr-1",
                        attrs: { variant: "info" },
                        on: { click: _vm.openModalForCreate },
                      },
                      [
                        _c("feather-icon", {
                          staticClass: "mr-50",
                          attrs: { icon: "PlusIcon" },
                        }),
                        _c("span", { staticClass: "align-middle" }, [
                          _vm._v(_vm._s(_vm.$t("Pipeline"))),
                        ]),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
              {
                key: "head(team_head)",
                fn: function (data) {
                  return [
                    _c(
                      "div",
                      {
                        staticClass: "mt-1 w-100 text-center text-nowrap",
                        staticStyle: { "padding-bottom": "2px" },
                      },
                      [
                        _vm._v(" " + _vm._s(data.label) + " "),
                        data.field.sortable
                          ? [
                              _c("feather-icon", {
                                class: {
                                  "text-primary":
                                    !_vm.sortDesc &&
                                    _vm.sortBy === data.field.key,
                                  "text-secondary":
                                    _vm.sortDesc ||
                                    _vm.sortBy !== data.field.key,
                                },
                                attrs: { icon: "ChevronUpIcon" },
                              }),
                              _c("feather-icon", {
                                class: {
                                  "text-primary":
                                    _vm.sortDesc &&
                                    _vm.sortBy === data.field.key,
                                  "text-secondary":
                                    !_vm.sortDesc ||
                                    _vm.sortBy !== data.field.key,
                                },
                                attrs: { icon: "ChevronDownIcon" },
                              }),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                    _c("b-form-select", {
                      attrs: {
                        options: _vm.userList,
                        "value-field": "id",
                        "text-field": "name",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.search("team_head", _vm.form.team_head)
                        },
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "first",
                            fn: function () {
                              return [
                                _c("b-form-select-option", {
                                  attrs: { value: "" },
                                }),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                      model: {
                        value: _vm.form.team_head,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "team_head", $$v)
                        },
                        expression: "form.team_head",
                      },
                    }),
                  ]
                },
              },
              {
                key: "head(team_lead)",
                fn: function (data) {
                  return [
                    _c(
                      "div",
                      {
                        staticClass: "mt-1 w-100 text-center text-nowrap",
                        staticStyle: { "padding-bottom": "2px" },
                      },
                      [
                        _vm._v(" " + _vm._s(data.label) + " "),
                        data.field.sortable
                          ? [
                              _c("feather-icon", {
                                class: {
                                  "text-primary":
                                    !_vm.sortDesc &&
                                    _vm.sortBy === data.field.key,
                                  "text-secondary":
                                    _vm.sortDesc ||
                                    _vm.sortBy !== data.field.key,
                                },
                                attrs: { icon: "ChevronUpIcon" },
                              }),
                              _c("feather-icon", {
                                class: {
                                  "text-primary":
                                    _vm.sortDesc &&
                                    _vm.sortBy === data.field.key,
                                  "text-secondary":
                                    !_vm.sortDesc ||
                                    _vm.sortBy !== data.field.key,
                                },
                                attrs: { icon: "ChevronDownIcon" },
                              }),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                    _c("b-form-select", {
                      attrs: {
                        options: _vm.userList,
                        "value-field": "id",
                        "text-field": "name",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.search("team_lead", _vm.form.team_lead)
                        },
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "first",
                            fn: function () {
                              return [
                                _c("b-form-select-option", {
                                  attrs: { value: "" },
                                }),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                      model: {
                        value: _vm.form.team_lead,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "team_lead", $$v)
                        },
                        expression: "form.team_lead",
                      },
                    }),
                  ]
                },
              },
              {
                key: "cell(team_head)",
                fn: function (row) {
                  return _vm._l(_vm.userList, function (item, index) {
                    return _c(
                      "span",
                      { key: index },
                      _vm._l(row.item.members, function (member) {
                        return _c("div", [
                          item.id === member.user.id &&
                          member.role === "TEAM_HEAD"
                            ? _c("span", [_vm._v(_vm._s(item.name))])
                            : _c("span"),
                        ])
                      }),
                      0
                    )
                  })
                },
              },
              {
                key: "cell(team_lead)",
                fn: function (row) {
                  return _vm._l(_vm.userList, function (item, index) {
                    return _c(
                      "span",
                      { key: index },
                      _vm._l(row.item.members, function (member) {
                        return _c("div", [
                          item.id === member.user.id &&
                          member.role === "TEAM_LEAD"
                            ? _c("span", [_vm._v(_vm._s(item.name))])
                            : _c("span"),
                        ])
                      }),
                      0
                    )
                  })
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: { id: "modal-create-pipeline", "hide-footer": "", size: "xl" },
          model: {
            value: _vm.isShow,
            callback: function ($$v) {
              _vm.isShow = $$v
            },
            expression: "isShow",
          },
        },
        [
          _c("el-form", [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.isLoading,
                    expression: "isLoading",
                  },
                ],
                staticClass: "card p-2",
              },
              [
                _c(
                  "el-descriptions",
                  {
                    staticClass: "margin-top",
                    attrs: {
                      direction: "vertical",
                      title: _vm.$t(_vm.pipelineTitle),
                      border: "",
                      column: 2,
                    },
                  },
                  [
                    _c(
                      "el-descriptions-item",
                      [
                        _c("template", { slot: "label" }, [
                          _c("i", { staticClass: "el-icon-guide" }),
                          _vm._v(" " + _vm._s(_vm.$t("Pipeline Name")) + " "),
                        ]),
                        _c("el-input", {
                          attrs: {
                            required: "",
                            "validate-event": true,
                            placeholder: "Input New pipeline Name",
                          },
                          model: {
                            value: _vm.form.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "name", $$v)
                            },
                            expression: "form.name",
                          },
                        }),
                      ],
                      2
                    ),
                    _c(
                      "el-descriptions-item",
                      [
                        _c("template", { slot: "label" }, [
                          _c("i", { staticClass: "el-icon-guide" }),
                          _vm._v(" " + _vm._s(_vm.$t("Sorting Order")) + " "),
                        ]),
                        _c("b-form-input", {
                          attrs: {
                            "value-field": "id",
                            "text-field": "order_nr",
                          },
                          model: {
                            value: _vm.form.order_nr,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "order_nr", $$v)
                            },
                            expression: "form.order_nr",
                          },
                        }),
                      ],
                      2
                    ),
                    _c(
                      "el-descriptions-item",
                      { attrs: { span: "2" } },
                      [
                        _c("template", { slot: "label" }, [
                          _c("i", { staticClass: "el-icon-guide" }),
                          _vm._v(" " + _vm._s(_vm.$t("Members")) + " "),
                        ]),
                        _c("table", { staticStyle: { width: "100%" } }, [
                          _c("thead", [
                            _c("tr", [
                              _c("th", [_vm._v(_vm._s(_vm.$t("Role")))]),
                              _c("th", [_vm._v(_vm._s(_vm.$t("User")))]),
                              _c("th", [_vm._v(_vm._s(_vm.$t("Manager")))]),
                              _c("th"),
                            ]),
                          ]),
                          _c(
                            "tbody",
                            _vm._l(_vm.form.members, function (member, rowId) {
                              return _c("tr", [
                                _c(
                                  "td",
                                  [
                                    _c("b-form-select", {
                                      attrs: {
                                        options: _vm.roleList,
                                        "value-field": "id",
                                        "text-field": "name",
                                      },
                                      model: {
                                        value: member.role,
                                        callback: function ($$v) {
                                          _vm.$set(member, "role", $$v)
                                        },
                                        expression: "member.role",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "td",
                                  [
                                    _c("b-form-select", {
                                      attrs: {
                                        options: _vm.userList,
                                        "value-field": "id",
                                        "text-field": "name",
                                      },
                                      model: {
                                        value: member.user.id,
                                        callback: function ($$v) {
                                          _vm.$set(member.user, "id", $$v)
                                        },
                                        expression: "member.user.id",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "td",
                                  [
                                    member.role !== "TEAM_HEAD" &&
                                    member.role !== "TEAM_LEAD"
                                      ? _c("b-form-select", {
                                          attrs: {
                                            options: _vm.userList,
                                            "value-field": "id",
                                            "text-field": "name",
                                          },
                                          model: {
                                            value: member.manager.id,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                member.manager,
                                                "id",
                                                $$v
                                              )
                                            },
                                            expression: "member.manager.id",
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                _c(
                                  "td",
                                  {
                                    staticStyle: {
                                      width: "100px",
                                      "text-align": "center",
                                    },
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        attrs: { href: "#" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.removeMember(rowId)
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-remove",
                                        }),
                                        _vm._v(" " + _vm._s(_vm.$t("Remove"))),
                                      ]
                                    ),
                                  ]
                                ),
                              ])
                            }),
                            0
                          ),
                          _c("tfoot", [
                            _c("tr", [
                              _c("td"),
                              _c("td"),
                              _c("td"),
                              _c(
                                "td",
                                {
                                  staticStyle: {
                                    width: "100px",
                                    "text-align": "center",
                                  },
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      attrs: { href: "#" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.addMember()
                                        },
                                      },
                                    },
                                    [
                                      _c("i", { staticClass: "el-icon-user" }),
                                      _vm._v(" " + _vm._s(_vm.$t("Add"))),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                        ]),
                      ],
                      2
                    ),
                    _c(
                      "el-descriptions-item",
                      { attrs: { span: "2" } },
                      [
                        _c("template", { slot: "label" }, [
                          _c("i", { staticClass: "el-icon-guide" }),
                          _vm._v(" " + _vm._s(_vm.$t("Stages")) + " "),
                        ]),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "overflow-x": "scroll",
                                },
                                attrs: { md: "12" },
                              },
                              [
                                _c(
                                  "draggable",
                                  _vm._b(
                                    {
                                      attrs: { draggable: ".draggable-stage" },
                                      on: {
                                        start: function ($event) {
                                          _vm.drag = true
                                        },
                                        end: function ($event) {
                                          _vm.drag = false
                                        },
                                      },
                                      model: {
                                        value: _vm.form.stageList,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "stageList", $$v)
                                        },
                                        expression: "form.stageList",
                                      },
                                    },
                                    "draggable",
                                    _vm.dragOptions,
                                    false
                                  ),
                                  [
                                    _c(
                                      "transition-group",
                                      {
                                        staticStyle: { display: "flex" },
                                        attrs: {
                                          type: "transition",
                                          name: !_vm.drag ? "flip-list" : null,
                                        },
                                      },
                                      _vm._l(
                                        _vm.form.stageList,
                                        function (stage, k) {
                                          return _c(
                                            "b-card",
                                            {
                                              key: k,
                                              staticClass:
                                                "mb-30 cursor-pointer",
                                              class: !stage.is_protected
                                                ? "draggable-stage"
                                                : "",
                                              staticStyle: {
                                                flex: "1 1 0%",
                                                padding: "0",
                                              },
                                            },
                                            [
                                              _c("div", [
                                                _c(
                                                  "div",
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("Stage Name")
                                                        )
                                                      ),
                                                    ]),
                                                    _c("el-input", {
                                                      staticClass:
                                                        "text-muted mb-1",
                                                      attrs: {
                                                        disabled:
                                                          stage.is_protected,
                                                      },
                                                      model: {
                                                        value: stage.name,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            stage,
                                                            "name",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "stage.name",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "div",
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("Probability")
                                                        )
                                                      ),
                                                    ]),
                                                    _c("el-input", {
                                                      staticClass:
                                                        "text-muted mb-1",
                                                      attrs: {
                                                        disabled:
                                                          stage.is_protected,
                                                      },
                                                      model: {
                                                        value:
                                                          stage.deal_probability,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            stage,
                                                            "deal_probability",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "stage.deal_probability",
                                                      },
                                                    }),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "div",
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "Valid Organization Statuses"
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                    _c("br"),
                                                    _c(
                                                      "el-select",
                                                      {
                                                        staticClass:
                                                          "text-muted mb-1",
                                                        staticStyle: {
                                                          width: "100%",
                                                        },
                                                        attrs: {
                                                          disabled:
                                                            stage.is_protected,
                                                          multiple: "multiple",
                                                        },
                                                        model: {
                                                          value:
                                                            stage.valid_statuses,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              stage,
                                                              "valid_statuses",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "stage.valid_statuses",
                                                        },
                                                      },
                                                      _vm._l(
                                                        _vm.approvalStatusList,
                                                        function (item) {
                                                          return _c(
                                                            "el-option",
                                                            {
                                                              key: item.id,
                                                              attrs: {
                                                                label:
                                                                  item.name,
                                                                value: item.id,
                                                              },
                                                            }
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                !stage.id && !stage.is_protected
                                                  ? _c(
                                                      "div",
                                                      [
                                                        _c("feather-icon", {
                                                          staticClass:
                                                            "text-muted",
                                                          staticStyle: {
                                                            cursor: "pointer",
                                                          },
                                                          attrs: {
                                                            icon: "Trash2Icon",
                                                            size: "24",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.deleteStage(
                                                                k,
                                                                stage
                                                              )
                                                            },
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                              ]),
                                            ]
                                          )
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      2
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  [
                    _c(
                      "el-button",
                      {
                        staticStyle: {
                          float: "right",
                          width: "200px",
                          background: "#66b1ff",
                          border: "#66b1ff",
                          margin: "20px 0 20px 20px",
                        },
                        attrs: { type: "primary", icon: "el-icon-check" },
                        on: {
                          click: function ($event) {
                            return _vm.save()
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("Save Pipeline")) + " ")]
                    ),
                    _c(
                      "el-button",
                      {
                        staticStyle: {
                          float: "right",
                          margin: "20px 0",
                          width: "200px",
                          background: "#fd7e14",
                          border: "#fd7e14",
                        },
                        attrs: { type: "primary", icon: "el-icon-plus" },
                        on: {
                          click: function ($event) {
                            return _vm.addStage()
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("Add Stage")) + " ")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }